import { render } from "./MessageInput.vue?vue&type=template&id=0a92b8aa&scoped=true"
import script from "./MessageInput.vue?vue&type=script&lang=js"
export * from "./MessageInput.vue?vue&type=script&lang=js"

import "./MessageInput.vue?vue&type=style&index=0&id=0a92b8aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a92b8aa"]])

export default __exports__